import { Button, Layout, Tag, Space, message, Table, Typography, Popconfirm, Card, Pagination } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MenuOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import axios from "axios";

const { Header } = Layout;
const { Text } = Typography;

const AllAsana = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [asanas, setAsanas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const capitalize = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);

  const navigate = useNavigate();

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // Fetch all asanas
  useEffect(() => {
    fetchAsanas();
  }, []);

  const fetchAsanas = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/asanadetails`);
      const list = res.data.asanas || res.data;
      setAsanas(list);
      // After a delete the current page may no longer exist: step back to the last one
      setCurrentPage((p) => Math.min(p, Math.max(1, Math.ceil(list.length / pageSize))));
    } catch (err) {
      console.log(err);
      message.error("Failed to fetch Asanas");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.delete(`${BASE_URL}/asanadetails/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        message.success("Asana deleted successfully!");
        fetchAsanas(); // refresh table
      } else {
        message.error(res.data.message || "Delete failed");
      }
    } catch (err) {
      console.log(err);
      message.error("Error deleting Asana");
    }
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(size !== pageSize ? 1 : page);
    setPageSize(size);
  };

  const mobileAsanas = asanas.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  const columns = [
    {
      title: "Asana Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <b style={{ fontSize: 15 }}>{text}</b>,
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      render: (level) => <Tag color="blue">{level}</Tag>,
    },
    {
      title: "Pose Type",
      dataIndex: "poseType",
      key: "poseType",
      render: (types) =>
        types?.map((t, i) => (
          <Tag color="purple" key={i}>
            {t}
          </Tag>
        )),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="default"
            onClick={() => navigate(`/view-asana/${record._id}`)}
          >
            View
          </Button>

          <Button
            type="primary"
            onClick={() => navigate(`/edit-asana/${record._id}`)}
          >
            Edit
          </Button>

          <Popconfirm
            title="Delete Asana"
            description="Are you sure you want to delete this Asana?"
            okText="Delete"
            okType="danger"
            icon={<ExclamationCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => handleDelete(record._id)}
          >
            <Button danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header
          className="MainHeader"
        >
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>All Asanas</Text>
          </div>
        </Header>
        {
          isMobile ? (
            <div>
              {mobileAsanas.map((asana) => (

                <Card
                  key={asana._id}
                  style={{
                    marginBottom: 12,
                    borderRadius: 12,
                  }}
                  bodyStyle={{ padding: 16 }}
                >

                  {/* Top Row */}

                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 10
                  }}>

                    <Text type="secondary">
                      {asana.name?.substring(0, 8).toUpperCase()}
                    </Text>

                    <Text
                      style={{
                        background: "#e6f4ea",
                        color: "#28a745",
                        padding: "2px 10px",
                        borderRadius: 20,
                        fontSize: 12,
                      }}
                    >
                      ● {asana.level}
                    </Text>

                  </div>


                  {/* Middle */}

                  <div style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 10
                  }}>

                    <img
                      src={asana.image || "https://via.placeholder.com/40"}
                      alt=""
                      style={{
                        width: 45,
                        height: 45,
                        borderRadius: "50%",
                        objectFit: "cover"
                      }}
                    />

                    <div>

                      <Text strong>
                        {asana.name}
                      </Text>

                      <br />

                      <Text type="secondary">
                        {asana.poseType?.join(", ")}
                      </Text>

                    </div>

                  </div>


                  {/* Bottom */}

                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 13
                  }}>

                    <div>

                      <div>
                        <Text type="secondary">
                          Created on
                        </Text>
                      </div>

                      <div>
                        {new Date(asana.createdAt).toLocaleDateString()}
                      </div>

                    </div>
                    <div>
                      <div>
                        <Text type="secondary">
                          Level
                        </Text>
                      </div>

                      <div>
                        {asana.level}
                      </div>

                    </div>
                  </div>
                  {/* Actions */}

                  <Space style={{ marginTop: 12 }}>

                    <Button
                      size="small"
                      onClick={() =>
                        navigate(`/view-asana/${asana._id}`)
                      }
                    >
                      View
                    </Button>

                    <Button
                      size="small"
                      type="primary"
                      onClick={() =>
                        navigate(`/edit-asana/${asana._id}`)
                      }
                    >
                      Edit
                    </Button>

                    <Popconfirm
                      title="Delete Asana?"
                      onConfirm={() =>
                        handleDelete(asana._id)
                      }
                    >

                      <Button
                        size="small"
                        danger
                      >
                        Delete
                      </Button>

                    </Popconfirm>

                  </Space>

                </Card>

              ))}

              <div style={{ textAlign: "center", margin: "16px 0" }}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={asanas.length}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                  simple
                />
              </div>
            </div>

          ) : (

            <Table
              columns={columns}
              dataSource={asanas}
              loading={loading}
              rowKey="_id"
              bordered
              pagination={{
                current: currentPage,
                pageSize,
                total: asanas.length,
                showSizeChanger: true,
                pageSizeOptions: [6, 10, 20, 50],
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} asanas`,
                onChange: handlePageChange,
              }}
            />

          )
        }
      </Layout>
    </Layout>
  );
};

export default AllAsana;
